import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="presence-selection"
export default class extends Controller {
  
  removeRow(e) {
    const totalSlots = this.element.querySelectorAll(".slot-row").length
    const groupSlots = e.target.closest(".slot-group").querySelectorAll(".slot-row").length

    if (totalSlots === 1) {
      this.element.remove() // Remove the modal
    } else if (groupSlots === 1) {
      e.target.closest(".slot-group").remove() // Remove the group
    } else {
      e.target.closest(".slot-row").remove() // Remove the row
    }
  }
  
}
